<template>
  <div class="flex">
    <div
      v-if="!detailView && (topic.hasMedia || topic.hasPicture)"
      v-tooltip="'Topic contains multimedia'"
      class="ml-2"
    >
      <lm-icon icon="mmsOutline" class="text-gray-500" />
    </div>
    <div v-if="topic.priority" v-tooltip="'Important topic'" class="ml-2">
      <lm-icon icon="announcement" class="text-gray-500" />
    </div>
    <lm-state-button-mini
      v-if="!detailView"
      class="ml-2px"
      :selected="votedPositive"
      :label="topic.positiveVotes.toString()"
      :tooltip="votedPositive ? 'Unvote topic' : 'Vote topic'"
      @click="voteTopic"
    />
    <div class="relative">
      <lm-summary-comment
        class="ml-2"
        :num-comments="topic.commentCount.toString()"
        :new-comments="topic.currentUser.unreadComments > 0"
        :tooltip="lastComment"
        @click="$emit('open-comments', $event)"
      />
    </div>
    <star-button
      class="ml-2"
      :checked="topic.currentUser.favorited || false"
      @click="favoriteTopic"
    />
    <lm-dropdown
      v-if="options.length > 0"
      class="ml-2px"
      :items="options"
      auto-close
      @select="onSelect"
    />
  </div>
</template>

<script>
import LmStateButtonMini from '@/components/ui/button/LmStateButtonMini'
import LmDropdown from '@/components/ui/LmDropdown'
import LmIcon from '@/components/ui/LmIcon'
import LmSummaryComment from '@/components/ui/LmSummaryComment'
import StarButton from '@/components/ui/StarButton'
import {Events, Modal} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import {mapGetters} from 'vuex'
export default {
  name: 'TopicActions',
  components: {
    LmIcon,
    LmStateButtonMini,
    LmSummaryComment,
    StarButton,
    LmDropdown
  },
  props: {
    topic: {
      type: Object,
      required: true
    },
    detailView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'hasManagerRightsActor',
      'inAuthorWindowPermission',
      'isStartup'
    ]),
    ...mapGetters({topicsView: 'preferences/topicsView'}),
    options() {
      const actions = []
      if (this.isStartup) {
        actions.push({action: 'addToPremise', label: 'Add to Premise'})
      } else {
        actions.push({action: 'createInsight', label: 'New Insight'})
        actions.push({action: 'addToInsight', label: 'Add to Insight'})
      }
      if (!this.topic.currentUser.visited) {
        actions.push({action: 'read', label: 'Mark as read'})
      }
      if (this.adminRights) {
        actions.push({action: 'edit', label: 'Edit topic'})
        actions.push({action: 'delete', label: 'Delete topic'})
      }
      return actions
    },
    adminRights() {
      return (
        this.hasManagerRightsActor({_id: this.topic.actorId}) ||
        this.inAuthorWindowPermission(this.topic)
      )
    },
    lastComment() {
      if (this.topic.commentCount === 0) return ''
      return `Last comment: ${this.$options.filters.dateFromNow(
        this.topic.lastComment
      )} ago`
    },
    votedPositive() {
      return this.topic.currentUser.positiveVote || false
    }
  },
  methods: {
    favoriteTopic() {
      let v = !this.topic.currentUser.favorited
      this.$store.dispatch('favoriteTopic', {topic: this.topic, value: v})
    },
    openTopic(e) {
      this.$emit('open-topic', e)
    },
    onSelect(item) {
      switch (item.action) {
        case 'delete':
          this.deleteTopic()
          break
        case 'edit':
          this.editTopic()
          break
        case 'read':
          this.markAsRead()
          break
        case 'addToPremise':
          this.addTo(Modal.TOPIC_TO_PREMISE)
          break
        case 'addToInsight':
          this.addTo(Modal.TOPIC_TO_INSIGHT)
          break
        case 'createInsight':
          this.createInsight()
          break
      }
    },
    editTopic() {
      this.$emit('edit-topic')
    },
    deleteTopic() {
      let params = {
        entity: 'topic',
        prompt: 'Are you sure you want to delete this topic?'
      }
      EventHub.emit(Events.OPEN_CONFIRM, params, this.doDeleteTopic)
    },
    doDeleteTopic() {
      this.$store.dispatch('deleteTopic', this.topic).then(() => {
        this.$emit(Events.TOPIC_DELETED)
        EventHub.emit(Events.SHOW_SNACKBAR, 'Topic deleted')
      })
    },
    markAsRead() {
      this.$store.dispatch('markAsReadTopic', this.topic)
    },
    addTo(modal) {
      this.$store.commit('addBulkTopic', this.topic._id)
      this.$router.pushQuery({modal})
    },
    createInsight() {
      this.$store.commit('insights/helpers/addTempTopic', this.topic._id)
      this.$router.pushQuery({modal: Modal.NEW_INSIGHT})
    },
    voteTopic() {
      let payload = {
        topic: this.topic,
        vote: {positiveVote: !this.votedPositive}
      }
      this.$store.dispatch('voteTopic', payload)
    }
  }
}
</script>
